import { DocumentUploadDialog } from "minimals-template/components/upload/document-upload-dialog"

export function ExcelImportDialog({ ...props }) {
    return (
        <DocumentUploadDialog
            title="Add Assets via Excel File"
            fileSelectText="Select Excel File"
            acceptedFileFormat={{
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            }}
            {...props}
        />
    )
}
